import {STORE_PERMISSION_ACTIONS_TYPES} from '../libs/constants'
import Vue from 'vue'
import Router from 'vue-router'
import util from '../libs/util'
import LoadingBar from '../components/loading-bar'
import Main from '../manager/manager_index.vue'
import store from '../store'
import mainRouter from './main-routers'
import pageRouters from './page-routers'
import gridRouters from './grid-routers'
import customMainRouter from '../custom/router/custom-main-routers'
import customPageRouters from '../custom/router/custom-page-routers'
import customGridRouters from '../custom/router/custom-grid-routers'

Vue.use(Router)

const router = new Router({
  base: '/np/',
  routes: [
    mainRouter,
    ...pageRouters,
    customMainRouter,
    ...customPageRouters
  ]
})

export const permissionRouterMap = [
  {
    path: '/grid',
    name: 'grid',
    component: Main,
    children: [
      ...gridRouters,
      ...customGridRouters
    ]
  },
  {
    path: '/alone',
    name: 'alone',
    component: Main,
    children: []
  },
  {
    path: '*',
    name: 'error-404',
    component: (resolve) => require(['../components/error-page/404.vue'], resolve)
  }
]

let handleApiPage = function (to, from, next) {
  if (to.name === 'apiNoToken') {
    // 跳转到无token
    next()
  } else if (util.token()) {
    // 有token且已访问过

    next()
  } else {
    // 授权超时或首次访问
    next({name: 'apiNoToken'})
  }
}

router.beforeEach((to, from, next) => {
  LoadingBar.start()
  if (to.name === 'entrance') { // 登录入口
    next()
  } else if (to.path.startsWith('/api')) {
    handleApiPage(to, from, next)
  } else if (!util.token() && to.name !== 'login') { // 未登录时跳转到登录页
    next({name: 'login'})
  } else if (util.token() && to.name === 'login') { // 登录后访问登录页时直接重定向到主页
    next({name: 'home_index'})
  } else if (util.token()) { // 用户已登录
    // 切换前路由先判断路由表是否初始化，没有初始化就先初始化，已经初始化则直接切换路由
    if (!store.state.permission.routersInitialized) {
      store.dispatch(STORE_PERMISSION_ACTIONS_TYPES.INIT_ROUTERS).then(() => {
        // 动态添加可访问路由表
        router.addRoutes(permissionRouterMap)
        // 初始化登录后需要的数据
        store.dispatch('initStateAfterLogin')
        let defaultMenu = store.state.app.defaultMenu // 配置的默认打开的菜单
        let savedCurrentPageId = store.state.app.currentPageId // 浏览器缓存的当前页
        if (defaultMenu.id) {
          next({name: defaultMenu.routerName || defaultMenu.id})
        } else if (savedCurrentPageId !== '') {
          let topTabList = store.state.app.topTabList
          for (let i = 0; i < topTabList.length; i++) {
            if (topTabList[i].id === savedCurrentPageId) {
              next(util.getDestRouter(topTabList[i]))
              break
            }
          }
        } else {
          next({...to, replace: true}) // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a history record
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to) => {
  if (!to.matched || to.matched.length === 0) {
    router.push({name: 'error-404'})
  }
  LoadingBar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js